import { CalendarContext } from './Calendar.context';
import useCalendar from './Calendar.hook';
import { tCalendarProviderProps } from './Calendar.types';

export default function CalendarProvider(
  props: tCalendarProviderProps,
): React.ReactElement {
  const { children } = props;
  const calendar = useCalendar();

  return (
    <CalendarContext.Provider value={calendar}>
      {children}
    </CalendarContext.Provider>
  );
}
